<template>
  <div class="input-content filter-field">
    <!-- <el-dropdown class="filter-model-dropdown" trigger="click" v-if="showSelect">
      <div class="el-dropdown-link">{{showMenu}}</div>
      <el-dropdown-menu class="filter-dropdown-menu" slot="dropdown">
        <el-dropdown-item v-for="item in options" :key="item.value" @click.native="handleCommand(item)">
          {{item.label}} {{item.describe}}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown> -->
    <el-input v-bind="$attrs" v-model="value" clearable class="ybl-input" @change="inputChange"></el-input>
  </div>
</template>
<script>
export default {
  name: 'yblInput',
  model: {
    prop: 'item',
    event: 'change'
  },
  props: {
    showSelect: { // 是否可以选择
      type: Boolean,
      default: () => false
    },
    item: {
      type: String | Number,
      default: () => ''
    }
  },
  data () {
    return {
      value: '',
      select: 1,
      showMenu: '=',
      options: [{
        value: 1,
        label: '=',
        describe: '等于'
      }
        // {
        //   value: 2,
        //   label: '!=',
        //   describe: '不等于'
        // }, {
        //   value: 3,
        //   label: '=',
        //   describe: '等于任意一个'
        // }, {
        //   value: 4,
        //   label: '!=',
        //   describe: '不等于任意一个'
        // }
      ]
    }
  },
  created () {
    this.value = this.item
  },
  mounted () {
  },
  methods: {
    handleCommand (item) {
      this.showMenu = item.label
    },
    inputChange (value) {
      this.$emit('change', value)
    }
  },
  watch: {
    'item': function (newVal, oldVal) {
      this.value = newVal
    }
  }
}
</script>
<style lang="less" scoped>
@import "../assets/less/color.less";
.input-content {
  .ybl-input {
    width: 190px;
    /deep/.el-input {
      .el-input__inner {
        border-radius: 2px;
        font-size: 12px;
        &::-webkit-input-placeholder {
          font-size: 12px;
          color: @placeholder-color;
        }
      }
    }
  }
  &.filter-field {
    min-width: 190px;
    display: flex;
    align-items: center;
    .filter-model-dropdown {
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      cursor: pointer;
      background-color: #fff;
      border: 1px solid #dde0e6;
      border-radius: 2px 0px 0px 2px;
      border-right: none;
      flex: none;
      .el-dropdown-link {
        padding: 6px;
        color: #a4a5a7;
        line-height: 1;
        width: 14px;
        height: 14px;
        text-align: center;
      }
    }
    /deep/.el-input {
      .el-input__inner {
        border-radius: 2px;
      }
    }
    /deep/.filter-model-dropdown + .el-input {
      .el-input__inner {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }
  }
  /deep/.el-input-group__prepend {
    background-color: #fff;
    padding: 0 16px;
    border-radius: 2px;
  }
  &_prepend {
    width: 34px;
    margin-left: -17px;
    // height: 30px;
    // background-color: #fff;
    /deep/.el-input__suffix {
      display: none;
    }
    /deep/ .el-input {
      width: 34px;
      min-width: 34px;
      .el-input__inner {
        width: 34px;
        padding: 0 10px 0 12px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/input.vue